import host from './host';
import { AppVersion } from './app';

// * 通用
export const LogoWhite = '/favicon.png';
export const Logo = '/favicon-w.jpg';
export const AppIcon = '/static/icons/ic_launcher.png';
export const PlusRedIcon = '/static/home/plus_red.gif';
export const PlusWhiteIcon = '/static/home/plus_white.svg';

export const hundian = '/static/home/hundian.jpg';
export const jiaotongting = '/static/home/jiaotongting.jpg';
export const pinshu = '/static/home/pinshu.jpg';
export const QRCode = '/static/qrcode.jpg';
export const sixpart = '/static/home/sixpart.jpg';
export const xitang = '/static/home/xitang.jpg';
export const hudongka = '/static/home/hudongka.jpg';
export const xipin1 = '/static/home/xipin1.jpg';

export const shop0 = '/static/home/shop0.jpg';
export const shop1 = '/static/home/shop1.jpg';
export const shop2 = '/static/home/shop2.jpg';
export const shop3 = '/static/home/shop3.jpg';
export const shop4 = '/static/home/shop4.jpg';
export const shop5 = '/static/home/shop5.jpg';
export const shop6 = '/static/home/shop6.jpg';
export const shop7 = '/static/home/shop7.jpg';

export const game0 = '/static/home/web0.gif';
export const game1 = '/static/home/web1.gif';
export const game2 = '/static/home/web2.jpg';
export const game3 = '/static/home/web3.jpg';
export const game4 = '/static/home/web4.jpg';
export const game5 = '/static/home/web5.jpg';
export const game6 = '/static/home/web6.gif';
export const game7 = '/static/home/web7.jpg';
export const game8 = '/static/home/web8.jpg';
export const game10 = '/static/home/web10.jpg';
export const game11 = '/static/home/web11.jpg';
export const game12 = '/static/home/web12.jpg';
 export const game13 = '/static/home/web13.jpg';
 export const game14 = '/static/home/web14.jpg';
 export const game15 = '/static/home/web15.jpg';
 export const game16 = '/static/home/web16.gif';
  export const game17 = '/static/home/web17.gif';
   export const game18 = '/static/home/web18.jpg';
    export const game19 = '/static/home/web19.gif';
	export const game20 = '/static/home/web20.jpg';
	 export const game21 = '/static/home/web21.jpg';
	 	 export const game22 = '/static/home/web22.jpg';
// 01 焦点图
export const IndexVideo = '/static/home/index.mp4';
export const Poster = '/static/home/index-poster.jpg';
export const AppImg = '/static/icons/app_img.jpg';

// 02 硬件设施服务
export const Hardware01 = '/static/home/hardware_01.jpg';
export const Hardware02 = '/static/home/hardware_02.jpg';
export const Hardware03 = '/static/home/hardware_03.jpg';
export const Hardware04 = '/static/home/hardware_04.jpg';


export const IconPrev = '/static/home/icon-prev.png';
export const IconNext = '/static/home/icon-next.png';

// 服务
export const NewService01 = '/static/home/new_service_01.jpg';
export const NewService02 = '/static/home/new_service_02.jpg';
export const NewService03 = '/static/home/new_service_03.jpg';
export const CompanyBg = '/static/home/company_bg.jpg';

// 03 3D内容制作服务
export const Arrow = '/static/home/arrow.png';
export const Circle = '/static/home/circle.png';

export const Content3d01 = '/static/home/3d_01.jpg';
export const Content3d02 = '/static/home/3d_02.jpg';
export const Content3d03 = '/static/home/3d_03.jpg';
export const Content3d04 = '/static/home/3d_04.jpg';

// 04 算法及软件开发服务
export const Software01 = '/static/home/software_01.png';
export const Software02 = '/static/home/software_02.png';
export const Software05 = '/static/home/software_05.jpg';
export const Software04 = '/static/home/software_04.png';

// 05 算法及软件开发服务
export const Case01 = '/static/home/case_01.jpg';
export const Case02 = '/static/home/case_02.jpg';
export const Case03 = '/static/home/case_03.jpg';
export const Case04 = '/static/home/case_04.jpg';
export const Case05 = '/static/home/case_05.jpg';
export const Case06 = '/static/home/case_06.jpg';

// 06 联系我们
export const ContactBg = '/static/home/contact_bg.jpg';
export const CompanyAddress = '/static/home/map.jpg';

//我们的服务
export const iconSer1 = '/static/home/icon-ser1.png';
export const iconSer2 = '/static/home/icon-ser2.png';
export const iconSer3 = '/static/home/icon-ser3.png';
export const iconSer4 = '/static/home/icon-ser4.png';
export const iconSer5 = '/static/home/icon-ser5.png';
export const iconSer6 = '/static/home/icon-ser6.png';

export const DetailBg = '/static/home/detail_bg.png';
export const Service01 = '/static/home/service_01.jpg';
export const Service02 = '/static/home/service_02.png';
export const Service03 = '/static/home/service_03.jpg';
export const Service04 = '/static/home/service_04.jpg';
export const Service05 = '/static/home/service_05.png';
export const Service06 = '/static/home/service_06.png';
export const Service07 = '/static/home/service_07.png';
export const Service08 = '/static/home/service_08.png';
export const Service09 = '/static/home/service_09.jpg';
export const Service10 = '/static/home/service_10.png';


export const Company01 = '/static/home/company/1.png';
export const Company02 = '/static/home/company/2.png';
export const Company03 = '/static/home/company/3.png';
export const Company04 = '/static/home/company/4.png';
export const Company05 = '/static/home/company/5.png';
export const Company06 = '/static/home/company/6.png';
export const Company07 = '/static/home/company/7.png';
export const Company08 = '/static/home/company/8.png';
export const Company09 = '/static/home/company/9.png'; 
export const Company10 = '/static/home/company/10.png';
export const Company11 = '/static/home/company/11.png';
export const Company12 = '/static/home/company/12.png'; 
export const Company13 = '/static/home/company/13.jpg';
export const Company14 = '/static/home/company/14.png';
export const Company15 = '/static/home/company/15.png'; 
export const Company16 = '/static/home/company/16.png';
export const Company17 = '/static/home/company/17.png';
export const Company18 = '/static/home/company/18.png'; 
export const Company19 = '/static/home/company/19.png'; 
export const Company20 = '/static/home/company/20.png'; 
export const Company21 = '/static/home/company/21.png'; 
export const Company22 = '/static/home/company/22.png'; 
export const Company23 = '/static/home/company/23.png'; 
export const Company24 = '/static/home/company/24.png'; 
export const Company25 = '/static/home/company/25.png'; 
export const Company26 = '/static/home/company/26.jpg'; 
export const Company27 = '/static/home/company/27.jpg'; 
export const Company28 = '/static/home/company/28.jpg'; 
export const Company29 = '/static/home/company/29.png'; 
export const Company30 = '/static/home/company/30.png'; 